// Your business details, as they appear on quotes, contracts and invoices.
//
// The bracketed values are placeholders — replace them before sending anything
// to a real client. They're deliberately obvious rather than blank, so a
// missing detail shows up on the document instead of leaving a silent gap.
//
// Kept out of Firestore on purpose: these belong to you, not to any one
// record, and they change rarely. Documents snapshot what they need at the
// time they're issued, so changing an address later doesn't rewrite history.

export const BUSINESS = {
  name: 'DDHAPPS Ltd',
  addressLines: [
    '167 Mortimer road',
    'Itchen',
    'Southampton',
    'SO19 2HJ',
  ],
  companyNumber: '17365774',
  // Shown on the privacy policy so clients doing due diligence can verify us on
  // the ICO's public register rather than taking our word for it.
  icoNumber: 'ZC230285',

  // Shown on invoices so a client can pay by bank transfer. Behind a login
  // rather than in an email, which is where invoice redirection fraud happens.
  bank: {
    accountName: 'DDHAPPS Ltd.',
    sortCode: '60-83-71',
    accountNumber: '76786601',
  },
};

// How long a quote stays acceptable. Without an expiry, a quote from last year
// could still be accepted at last year's prices.
export const QUOTE_VALIDITY_DAYS = 30;

export function businessAddressLine() {
  return BUSINESS.addressLines.filter(Boolean).join(', ');
}
